import catalogue from './data/catalogue.json';
import archive from './data/archive.json';
import { useState } from 'preact/hooks';

// Match CodeIgniter's url_title(), including case, for existing incoming links.
export function slug(value) {
  return value.replace(/<[^>]*>/g, '').replace(/&#\d+?;|&\S+?;/g, '').replace(/\s+/g, '-').replace(/[^a-z0-9\-._]/gi, '').replace(/-+/g, '-').replace(/^-|-$/g, '').replace(/\.+$/, '');
}
export const workPath = (type, index, work) => `/c/detail/${type}/${index}/${slug(work.name)}`;
export function Works() {
  return <><h1>Works</h1><div class="works-wrp">{Object.entries(catalogue).map(([type, works]) => <section key={type}>
    <h2>{type}</h2><ul class={`works-list ${type}`}>{works.map((work, index) => <li key={index}>
      <a href={workPath(type, index, work)}><figure class={`img ${work.position || ''}`} style={{backgroundImage: `url("${work.photos[0]}")`}} /><figcaption>{work.name}</figcaption></a>
    </li>)}</ul>
  </section>)}</div></>;
}
export function WorkDetail({ work, type }) {
  return <><h1>{work.name}</h1><div class="row detail"><div class={`column ${!work.material && !work.size?.length ? 'solo' : ''}`}>
    <a href={work.photos[0]} data-lightbox="gallery"><img src={work.photos[0]} alt={work.name} /></a>
  </div>{(work.material || work.size?.length) && <div class="column"><p>{work.material}</p>{work.size?.map(size => <p key={size}>{size}</p>)}</div>}</div>
    <ul class="works-list">{work.photos.slice(1).map(photo => <li key={photo}><a href={photo} data-lightbox="gallery"><figure class="img" role="img" aria-label={`${work.name}, another view`} style={{backgroundImage:`url("${photo}")`}} /></a></li>)}</ul>
    <p class="return-link"><a href="/c/works">← All works</a></p>
  </>;
}

export function ArchiveList({medium = 'bronze'}) {
  const [query, setQuery] = useState('');
  const works = archive.galleries.filter(work => (medium === 'bronze' ? ['bronze','marble'].includes(work.medium) : work.medium === medium) && work.item_name.toLowerCase().includes(query.toLowerCase()));
  return <><h1>{medium === 'scenario' ? 'Scenarios archive' : 'Sculptures archive'}</h1>
    <label class="archive-search">Find a work <input type="search" value={query} onInput={event=>setQuery(event.currentTarget.value)} /></label>
    <ul class="works-list">{works.map(work => <li key={work.id}><a href={`/c/dettaglio/${work.medium}/${work.id}`}>
      {work.photos[0] && <figure class="img" style={{backgroundImage:`url("${work.photos[0]}")`}} />}<figcaption>{work.item_name}</figcaption>
    </a></li>)}</ul>{!works.length && <p>No works match your search.</p>}
  </>;
}
export function ArchiveDetail({work, birth = false}) {
  const photos = birth ? work.birth : work.photos;
  return <><h1>{work.item_name}{birth ? ' — Birth of a sculpture' : ''}</h1><p>{work.medium} {work.size}{work.total_editions ? ` · Edition of ${work.total_editions}` : ''}</p>
    <ul class="works-list archive-photos">{photos.map(photo=><li key={photo}><a href={photo} data-lightbox="gallery"><img src={photo} alt={work.item_name} loading="lazy" /></a></li>)}</ul>
    {!!work.birth.length && <p><a href={birth ? `/c/dettaglio/${work.medium}/${work.id}` : `/c/dettaglio/${work.medium}/${work.id}/birth_of_a_sculpture`}>{birth ? 'Finished sculpture' : 'Birth of a sculpture'}</a></p>}
    <p><a href="/c/contacts">Price / Information</a></p>
  </>;
}
export { catalogue, archive };
